export default {
    CREATE_WORK_SPACE: "Создать пространство",
    SAVE: "Сохранить",
    SORT_BY_TITLE: "По названию",
    SORT_BY_CREATION: "По дате создания"
};
